export const wfBubble_15 = { 
    current : {
        backgroundColor: '#00E469',
        borderColor: '#00B654',
        color: 'white',
    }
}